import { Button, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { FormDialog, FormLayout, FormItem, Input } from "@formily/antd";
import { createSchemaField } from "@formily/react";
import { setting as settingService } from "@/services";
const schema = {
  type: "object",
  properties: {
    name: {
      type: "string",
      title: "名称",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    value: {
      type: "string",
      title: "分值",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
  },
};

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
  },
});

function AdditionalPointEditButton({ additionalPointId, token, callback }) {
  return (
    <FormDialog.Portal>
      <Button
        icon={<EditOutlined />}
        size="small"
        onClick={() => {
          FormDialog({ title: "修改" }, "modal-dialog", () => {
            return (
              <FormLayout labelCol={6} wrapperCol={16}>
                <SchemaField
                  schema={schema}
                  scope={{
                    token,
                  }}
                />
              </FormLayout>
            );
          })
            .forOpen((payload, next) => {
              settingService
                .getAdditionalPoint(additionalPointId, token)
                .then((data) => {
                  next({
                    initialValues: {
                      name: data?.name,
                      value: data?.value,
                    },
                  });
                });
            })
            .forConfirm((payload, next) => {
              settingService
                .updateAdditionalPoint(additionalPointId, payload.values, token)
                .then((res) => {
                  message.success("修改成功");
                  callback(Date.now());
                })
                .catch((err) => {
                  message.error(err.message || err);
                })
                .finally(() => {
                  next(payload);
                });
            })
            .open();
        }}
      />
    </FormDialog.Portal>
  );
}

export default AdditionalPointEditButton;
